import type { Epic } from 'Flux/index.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'
import { organizationSlice } from '../../../Slice/Organization/OrganizationSlice.js'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'

export const DeleteOrganizationLogoEpic: Epic = (action$, state$, { [organizationSlice.name]: organization, OrganizationRepository }) =>
  action$.pipe(
    filter(organization.deleteLogoRequest.match),
    mergeMap((action) => {
      return OrganizationRepository.deleteOrganizationLogo().pipe(
        mergeMap(() => of(organization.deleteLogoRequestSuccess(action.payload))),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(organization.deleteLogoRequestFailure(action.payload))
          })
        )
      )
    })
  )
